import { Divider, Drawer } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import "./side-drawer.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, batch } from "react-redux";
import { Character } from "../../interfaces/character";
import { store } from "../../redux/configure-store";
import { ToHitActions } from "../../redux/reducers/to-hit-reducer";
import { CharacterActions } from "../../redux/reducers/character-reducer";
import { StatsActions } from "../../redux/reducers/stats-reducer";
import { SavesActions } from "../../redux/reducers/saves-reducer";
import { SkillActions } from "../../redux/reducers/skills.reducer";
import { UserActions } from "../../redux/reducers/user-reducer";
import { ArmorActions } from "../../redux/reducers/armor-reducer";
import { setCookie } from "react-use-cookie";
import { signOutUser } from "../../api/user-api";

export interface DrawerProp {
  drawerStatus: boolean;
  setDrawerStatus: Dispatch<SetStateAction<boolean>>;
}
export const SideDrawer: React.FunctionComponent<DrawerProp> = (
  props: DrawerProp
): JSX.Element => {
  const navigate = useNavigate();
  const { drawerStatus, setDrawerStatus } = props;
  const char: Character = useSelector((state) => store.getState().character);
  const userId = useSelector((state) => store.getState().user.id);
  const toggleDrawer =
    (status: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setDrawerStatus(status);
    };
  const logOut = async () => {
    batch(() => {
      store.dispatch(StatsActions.clearStats());
      store.dispatch(SavesActions.clearSaves());
      store.dispatch(SkillActions.clearSkills());
      store.dispatch(CharacterActions.clearCharacter());
      store.dispatch(CharacterActions.clearCharacter());
      store.dispatch(ArmorActions.clearArmor());
      store.dispatch(ToHitActions.clearToHits());
      store.dispatch(UserActions.clearUser());
    });
    setCookie("token", "", { days: -1 });
    setDrawerStatus(false);
    await signOutUser()
      .then((arg) => {
        navigate("/");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Drawer anchor="left" open={drawerStatus} onClose={toggleDrawer(false)}>
        {userId !== "" && (
          <>
            <p className="shelfHeader">Characters</p>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to="/main/loadChar"
            >
              Load Characters
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to="/main/newChar"
            >
              Create Character
            </Link>
            <Divider />
            <p className="shelfHeader">Current Character</p>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/overview/${char.charID}`}
            >
              Overview
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Core Details"
                : "View Core Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/stats/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Stats Details"
                : "View Stats Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/save/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Saves Details"
                : "View Saves Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/acs/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Armor Class Details"
                : "View Armor Class Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/tohits/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit To Hits Details"
                : "View To Hits Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/feats/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Feats Details"
                : "View Feats Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/skills/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Skills Details"
                : "View Skills Details"}
            </Link>
            {char.isCaster && (
              <>
                <Link
                  className="pageLink"
                  onClick={toggleDrawer(false)}
                  to={`/character/spells/${char.charID}`}
                >
                  {char.userID === +userId
                    ? "View/Edit Spells Details"
                    : "View Spells Details"}
                </Link>
              </>
            )}
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/expendables/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Expendables Details"
                : "View Expendables Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/equipment/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Equipment Details"
                : "View Equipment Details"}
            </Link>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to={`/character/notes/${char.charID}`}
            >
              {char.userID === +userId
                ? "View/Edit Notes Details"
                : "View Notes Details"}
            </Link>
            <Divider />
          </>
        )}
        {userId === "" && (
          <>
            <p className="shelfHeader">Characters</p>
            <Link
              className="pageLink"
              onClick={toggleDrawer(false)}
              to="/main/loadChar"
            >
              Load Characters as Guest
            </Link>
          </>
        )}
        <p className="shelfHeader">User Status</p>
        <Link className="pageLink" onClick={toggleDrawer(false)} to={`/`}>
          Home
        </Link>
        {userId !== "" && (
          <Link
            className="pageLink"
            onClick={logOut}
            to={`/`}
            style={{ marginBottom: "24px" }}
          >
            Logout
          </Link>
        )}
      </Drawer>
    </div>
  );
};
